import { StaticBooleanConditionSchema } from '../../../../../../../inputs/expressions-editor/conditions/BooleanConditionSchema.ts';
import {
  type IWidgetAdvancedOption,
  type IWidgetOptionValue,
} from '../../../../../Widget.ts';

export const createDefaultOptionValue = (): IWidgetOptionValue => ({
  type: 'option',
  label: [{ type: 'text', text: '' }],
  value: '',
  visible: StaticBooleanConditionSchema.cast({}, { assert: false }),
  enabled: StaticBooleanConditionSchema.cast({}, { assert: false }),
});

export const createDefaultAdvancedOptionValue = (): IWidgetAdvancedOption => ({
  type: 'option',
  visible: StaticBooleanConditionSchema.cast({}, { assert: false }),
  enabled: StaticBooleanConditionSchema.cast({}, { assert: false }),
  values: {},
});
